import { TextInput } from "./TextInput";

interface EmailInputProps {
    id?: string;
    name?: string;
    isValid?: boolean;
    required?: boolean;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
}

export const isValidEmail = (value: string) => {
    return value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
};

export const EmailInput = ({
    id,
    name,
    isValid,
    required,
    value,
    onChange,
    placeholder,
    disabled,
}: EmailInputProps) => {
    const effectiveIsValid = isValidEmail(value) && isValid !== false;

    return (
        <TextInput
            id={id}
            name={name}
            type="email"
            autoComplete="email"
            required={required}
            placeholder={placeholder}
            value={value}
            onChange={(newValue) => onChange(newValue.trim())}
            disabled={disabled}
            isValid={!value || !!effectiveIsValid}
        />
    );
};
